import { FC, useCallback, useState } from 'react';
import { Switch, Typography, Space } from 'antd';
import { useUIDispatchContext } from 'providers/UI';
import { useTranslation } from 'react-i18next';
import { SettingsKeys } from '@medicusunion/front-utils';
import { useAuthDispatchContext, useAuthStateContext } from 'providers/Auth';
import { updateSettings } from 'services/api/profile';

import { Container } from './styled';
import AuthenticationModal from '../Modals/AuthenticationModal';
import { showRestError } from 'utils/showErrorMessage';
import { instance } from 'utils/api';

const { Text } = Typography;

const Auth2FA: FC = () => {
  const { t } = useTranslation();
  const { toggleModal } = useUIDispatchContext();
  const { refetchUserData } = useAuthDispatchContext();
  const { user } = useAuthStateContext();

  const [active, setActive] = useState(user?.settings?.auth2fa || false);

  const onToggleSwitch = useCallback(
    async (val: boolean) => {
      if (val) {
        const image = await instance.post('auth/qr');

        toggleModal('authentication', true, {
          qr: image?.data?.qr,
          secretCode: image?.data?.secret
        });
      } else {
        // merged server-side; send only the toggled key
        updateSettings({ [SettingsKeys.auth2fa]: false })
          .then(() => refetchUserData())
          .catch(err => showRestError(err));
      }

      setActive(val);
    },
    [toggleModal, refetchUserData]
  );

  return (
    <Container>
      <Space>
        <Switch checked={active} onChange={onToggleSwitch} />
        <Text>{t('profile.2fa.title')}</Text>
      </Space>
      <AuthenticationModal onCancel={() => setActive(false)} />
    </Container>
  );
};

export default Auth2FA;
